// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/xxi0uje.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon[data-v-3612a7cc]{cursor:pointer;transform:rotate(0deg);transition:transform .2s ease-in-out}.icon.expanded[data-v-3612a7cc]{transform:rotate(90deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
